import t from 'typy';
import { mapActions, mapState } from 'vuex';
import ConfirmationModalComponent from "./../../../../components/confirmation-modal.component";
import WarningModal from "../../../../components/warningModal.vue";

export default {
    name: "SmsPreCheckinNotice",
    components: {
        ConfirmationModalComponent,
        WarningModal
    },
    data() {
        return {
            settings: {},
            facility: {},
            data: {},
            message: {
                value: {
                    content: "",
                },
            },
            alertVisible: false,
            error: false,
            smsData: {},
            subscriptionInfo: {},
            charMaxLength: 30,
            confirmClicked: false,
            costSaverSetting: {
                value: {
                    enable: false
                }
            },
            warningText: "",
            isDisabled: true
        }
    },
    computed: {
        ...mapState('notificationControl', ['emailToggle', 'costSaverToggle']),

        charCount() {
            return this.message.value.content.length;
        },
        isContentValid() {
            return this.message.value.content.length >= 5 && this.message.value.content.length <= this.charMaxLength;
        }, 
    },

    async mounted() {
        this.facility = window._app_facility

        this.detectIfJaOrENg(this.message.value.content);
        this.updateMaxCharLength(this.$i18n.locale);
        await this.fetchSmsSubscriptionInfo();
        await this.fetchSmsSettings();
        await this.fetchSmsContent();
        await this.fetchSmsAnalytics();
        await this.fetchCostSaver();
    },

    watch: {
        "$i18n.locale"(newLocale) {
            this.updateMaxCharLength(newLocale);
        },
        "message.value.content"(newContent) {
            this.detectIfJaOrENg(newContent);
            if (newContent.length > this.charMaxLength) {
                this.message.value.content = newContent.substring(0, this.charMaxLength);
            }
        }
    },

    methods: {
        ...mapActions('notificationControl', ['setCostSaverToggle']),

        handleCostSaver(event) {

            const value = typeof event === "object" ? event.value : event;
            const smsToggle = this.data.enable;
            this.setCostSaverToggle(value);

            if(this.costSaverToggle) {
                this.warningText = this.$t("account-page-notif-control.schedule_pre_checkin_notice.sms_pre_checkin_notice.cost_saver_warning");

                if (!this.emailToggle || !smsToggle) {
                    this.$bvModal.show('warning');
                    this.setCostSaverToggle(false);
                } else {
                    return; 
                }
            }   
        },  

        updateMaxCharLength(locale) {
            this.charMaxLength = locale === "ja" ? 30 : 80;
        },

        onConfirmClick() {
            this.confirmClicked = true;

            if (this.message.value.content.length > 0 && this.isContentValid) {
                this.$bvModal.show("modal-confirmation");
            } else {
                this.showErrorAlert();
            }
        },

        detectIfJaOrENg(content) {
            if (!content.length) {
                // If empty, reset to the default based on locale
                this.updateMaxCharLength(this.$i18n.locale);
                return;
            }

            this.charMaxLength = /[\u3040-\u30FF\u4E00-\u9FFF]/.test(content) ? 30 : 80;
            if (content.length > this.charMaxLength) this.message.value.content = content.slice(0, this.charMaxLength);
        },

        onMessageInput() {
            const content = this.message.value.content;
            if (content.length > this.charMaxLength) this.message.value.content = content.slice(0, this.charMaxLength);
        },


        async fetchSmsSubscriptionInfo() {
            const response = await this.$lionheart.post('/v2/facility/sms/sms-subscription-info')
            this.subscriptionInfo = response.data.data
        },
        async fetchSmsAnalytics() {

            if (this.facility.id) {
                const response = await this.$lionheart.get(
                    `/v2/facility/sms/facility-analytics?facility_id=${this.facility.id}`
                );

                this.smsData = response.data.data
            }
        },

        async fetchSmsSettings() {
            const response = await this.$lionheart.get(
                "/v2/facility/notification-control/get-pcn-guide-sms-schedule"
            );

            const data = response.data.data;
            this.settings.dates = data.dates;
            this.settings.times = data.times;
            this.data = data.settings;
        },

        async fetchSmsContent() {
            const response = await this.$lionheart.get('/v2/facility/notification-control/get-pcn-sms-content');

            if (response.data.data && response.data.data.length > 0) {
                this.message.value.content = response.data.data[0].value.content;
            } else {
                this.message.value.content = "";
            }
        },

        async fetchCostSaver() {

            if(this.facility.id) {
                const response = await this.$lionheart.get(`/v2/facility-settings?facility_id=${this.facility.id}&name=pci_cost_saver&paginate=0`);

                if (response.data?.data && response.data?.data?.length > 0) {
                    this.costSaverSetting = response.data.data[0];
                    this.setCostSaverToggle(this.costSaverSetting['value']['enable'])
                }
            }

            
        },

        dateFormat(date) {
            const [year, month] = date.split('-');
            return `${year.slice(-2)}/${month}`;
        },

        showAlert() {
            this.alertVisible = true;

            setTimeout(() => {
                this.alertVisible = false;
            }, 5000);
        },

        removeHyperlinks(message) {
            return message.replace(/https?:\/\/[^\s]+/g, '').replace(/www\.[^\s]+/g, '');
        },

        showErrorAlert() {
            this.error = true;

            setTimeout(() => {
                this.error = false;
            }, 5000);
        },

        hideAlert() {
            this.alertVisible = false;
            this.error = false;
        },

        async setSmsMessage() {
            const createPayload = (message) => {
                return { content: `${message}` };
            };

            const cleanedMessage = this.removeHyperlinks(this.message.value.content);
            const payload = createPayload(cleanedMessage);
            const response = await this.$lionheart.post(
                "/v2/facility/notification-control/set-pcn-sms-content",
                payload
            );


            if (response.status === 200 || response.status === 201) {
                this.fetchSmsContent();
            } else {
                this.showErrorAlert();
            }
        },

        async setSmsSettings() {
            const response = await this.$lionheart.post(
                "/v2/facility/notification-control/set-pcn-guide-sms-schedule",
                this.data
            );

            if (response.status === 200 || response.status === 201) {
                this.showAlert();
            } else {
                this.showErrorAlert()
            }
        },

        async setCostSaver() {

            const payload = {
                "enable": this.costSaverToggle
            }

            const response = await this.$lionheart.post(
                '/v2/facility/notification-control/set-pcn-cost-saver',
                payload
            );

            if (response.status === 200 || response.status === 201) {
                this.showAlert();
            } else {
                this.showErrorAlert()
            }


        },

        async submitSms() {
            this.error = false;
            this.alertVisible = false;

            await this.setSmsSettings();
            await this.setCostSaver();
            await this.setSmsMessage();
           
        }
    }
}